import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const API = `${API_BASE}/mfg`;

export const mfgApi = {
  // departments (multi-department architecture)
  equipmentDepartments: () => axios.get(`${API}/equipment-departments`).then((r) => r.data),
  departments: () => axios.get(`${API}/departments`).then((r) => r.data),
  // suppliers
  suppliers: (params) => axios.get(`${API}/suppliers`, { params }).then((r) => r.data),
  createSupplier: (b) => axios.post(`${API}/suppliers`, b).then((r) => r.data),
  updateSupplier: (id, b) => axios.put(`${API}/suppliers/${id}`, b).then((r) => r.data),
  deleteSupplier: (id) => axios.delete(`${API}/suppliers/${id}`).then((r) => r.data),
  bulkDeleteSuppliers: (ids) => axios.post(`${API}/suppliers/bulk-delete`, { ids }).then((r) => r.data),
  importLegacySuppliers: (file) => { const fd = new FormData(); fd.append('file', file); return axios.post(`${API}/suppliers/import-legacy`, fd).then((r) => r.data); },
  // locations
  locations: () => axios.get(`${API}/locations`).then((r) => r.data),
  createLocation: (b) => axios.post(`${API}/locations`, b).then((r) => r.data),
  updateLocation: (id, b) => axios.put(`${API}/locations/${id}`, b).then((r) => r.data),
  deleteLocation: (id) => axios.delete(`${API}/locations/${id}`).then((r) => r.data),
  // items
  items: (params) => axios.get(`${API}/items`, { params }).then((r) => r.data),
  item: (id) => axios.get(`${API}/items/${id}`).then((r) => r.data),
  linkedAssets: (id) => axios.get(`${API}/items/${id}/linked-assets`).then((r) => r.data),
  itemStats: () => axios.get(`${API}/items/stats`).then((r) => r.data),
  nextSku: (prefix) => axios.get(`${API}/items/next-sku`, { params: { prefix } }).then((r) => r.data),
  categories: () => axios.get(`${API}/items/categories`).then((r) => r.data),
  createItem: (b) => axios.post(`${API}/items`, b).then((r) => r.data),
  updateItem: (id, b) => axios.put(`${API}/items/${id}`, b).then((r) => r.data),
  deleteItem: (id, force) => axios.delete(`${API}/items/${id}`, { params: force ? { force: true } : {} }).then((r) => r.data),
  archivedItems: () => axios.get(`${API}/items`, { params: { archived: true } }).then((r) => r.data),
  restoreItem: (id) => axios.post(`${API}/items/${id}/restore`).then((r) => r.data),
  bulkUpdateItemCategory: (item_ids, category_id) => axios.post(`${API}/items/bulk-category`, { item_ids, category_id }).then((r) => r.data),
  aiImportParse: (text, hint) => axios.post(`${API}/inventory/ai-import/parse`, { text, hint: hint || null }).then((r) => r.data),
  aiImportSettings: () => axios.get(`${API}/inventory/ai-import/settings`).then((r) => r.data),
  saveAiImportSettings: (body) => axios.put(`${API}/inventory/ai-import/settings`, body).then((r) => r.data),
  aiImportCommit: (body) => axios.post(`${API}/inventory/ai-import/commit`, body).then((r) => r.data),
  aiImportCreateBatch: (item_ids, source_hint) => axios.post(`${API}/inventory/ai-import/batches`, { item_ids, source_hint: source_hint || null }).then((r) => r.data),
  aiImportUndoBatch: (batch_id) => axios.post(`${API}/inventory/ai-import/batches/${batch_id}/undo`).then((r) => r.data),
  aiImportListBatches: (limit = 20) => axios.get(`${API}/inventory/ai-import/batches`, { params: { limit } }).then((r) => r.data),
  // item categories (品目カテゴリ)
  itemCategories: () => axios.get(`${API}/item-categories`).then((r) => r.data),
  createItemCategory: (b) => axios.post(`${API}/item-categories`, b).then((r) => r.data),
  makers: () => axios.get(`${API}/items/makers`).then((r) => r.data),
  // employees master (共通) - used for equipment owner, requester, etc.
  employees: () => axios.get(`${API_BASE}/employees`).then((r) => r.data),
  updateItemCategory: (id, b) => axios.patch(`${API}/item-categories/${id}`, b).then((r) => r.data),
  deleteItemCategory: (id) => axios.delete(`${API}/item-categories/${id}`).then((r) => r.data),
  // units of measure (単位)
  uoms: () => axios.get(`${API}/uoms`).then((r) => r.data),
  createUom: (b) => axios.post(`${API}/uoms`, b).then((r) => r.data),
  updateUom: (id, b) => axios.patch(`${API}/uoms/${id}`, b).then((r) => r.data),
  deleteUom: (id) => axios.delete(`${API}/uoms/${id}`).then((r) => r.data),
  // makers (メーカー) — iter_143f master editor
  makers: () => axios.get(`${API}/makers`).then((r) => r.data),
  createMaker: (b) => axios.post(`${API}/makers`, b).then((r) => r.data),
  updateMaker: (id, b) => axios.patch(`${API}/makers/${id}`, b).then((r) => r.data),
  deleteMaker: (id) => axios.delete(`${API}/makers/${id}`).then((r) => r.data),
  // lots / stock
  receive: (b) => axios.post(`${API}/receipts`, b).then((r) => r.data),
  // 出庫（使用・払出）— A2
  issue: (b) => axios.post(`${API}/issues`, b).then((r) => r.data),
  issueReasons: () => axios.get(`${API}/issue-reasons`).then((r) => r.data),
  developmentsForIssue: () => axios
    .get(`${process.env.REACT_APP_BACKEND_URL}/api/eng/developments`)
    .then((r) => (Array.isArray(r.data) ? r.data : [])),
  adjustLot: (id, b) => axios.post(`${API}/lots/${id}/adjust`, b).then((r) => r.data),
  transferLot: (id, b) => axios.post(`${API}/lots/${id}/transfer`, b).then((r) => r.data),
  transferBetweenDepartments: (b) => axios.post(`${API}/transfers`, b).then((r) => r.data),
  moves: (params) => axios.get(`${API}/moves`, { params }).then((r) => r.data),
  alerts: () => axios.get(`${API}/alerts`).then((r) => r.data),
  dashboard: () => axios.get(`${API}/dashboard`).then((r) => r.data),
  lookup: (code) => axios.get(`${API}/lookup`, { params: { code } }).then((r) => r.data),
  // equipment & tools (Phase 2)
  equipment: (params) => axios.get(`${API}/equipment`, { params }).then((r) => r.data),
  equipmentOne: (id) => axios.get(`${API}/equipment/${id}`).then((r) => r.data),
  myDepartment: () => axios.get(`${API}/my-department`).then((r) => r.data),
  equipmentCheck: (id, body) => axios.post(`${API}/equipment/${id}/check`, body).then((r) => r.data),
  equipmentStats: (params) => axios.get(`${API}/equipment/stats`, { params }).then((r) => r.data),
  // B2 · 設備番号は IT資産・備品・技術の設備台帳と共通（EQP）。先読みだけ。
  equipmentNextNo: () => axios.get(`${API}/equipment/next-no`).then((r) => r.data),
  // 由来プロジェクト（統合登録フォームの設備ブロック）
  projects: () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/planner/projects`).then((r) => r.data),
  equipmentImpact: () => axios.get(`${API}/equipment/impact`).then((r) => r.data),
  createEquipment: (b) => axios.post(`${API}/equipment`, b).then((r) => r.data),
  updateEquipment: (id, b) => axios.put(`${API}/equipment/${id}`, b).then((r) => r.data),
  setEquipmentStatus: (id, b) => axios.post(`${API}/equipment/${id}/status`, b).then((r) => r.data),
  // 2026-10-23 · 廃棄（理由必須）と その取り消し（管理者）
  undisposeEquipment: (id, reason) => axios.post(`${API}/equipment/${id}/undispose`, { reason }).then((r) => r.data),
  // 2026-11-04 · 受入確認（引き渡しのサインオフ）
  confirmAcceptance: (id, body) => axios.post(`${API}/equipment/${id}/acceptance`, body).then((r) => r.data),
  // 2026-10-23 · 削除（登録ミス）— 表に出さないだけ。番号は欠番のまま。
  softDeleteEquipment: (id, reason, force = false) => axios.post(`${API}/equipment/${id}/soft-delete`, { reason, force }).then((r) => r.data),
  deletedEquipment: () => axios.get(`${API}/equipment/deleted`).then((r) => r.data),
  restoreEquipment: (id) => axios.post(`${API}/equipment/${id}/restore`).then((r) => r.data),
  refreshSpareParts: (id) => axios.post(`${API}/equipment/${id}/refresh-spare-parts`).then((r) => r.data),
  undoSpareParts: (batchId) => axios.post(`${API}/equipment/spare-parts/undo/${batchId}`).then((r) => r.data),
  deleteEquipment: (id) => axios.delete(`${API}/equipment/${id}`).then((r) => r.data),
  // maintenance
  schedules: (params) => axios.get(`${API}/maint/schedules`, { params }).then((r) => r.data),
  createSchedule: (b) => axios.post(`${API}/maint/schedules`, b).then((r) => r.data),
  updateSchedule: (id, b) => axios.put(`${API}/maint/schedules/${id}`, b).then((r) => r.data),
  deleteSchedule: (id) => axios.delete(`${API}/maint/schedules/${id}`).then((r) => r.data),
  completeSchedule: (id, b) => axios.post(`${API}/maint/schedules/${id}/complete`, b).then((r) => r.data),
  logs: (params) => axios.get(`${API}/maint/logs`, { params }).then((r) => r.data),
  createCorrective: (b) => axios.post(`${API}/maint/logs`, b).then((r) => r.data),
  updateLog: (id, b) => axios.put(`${API}/maint/logs/${id}`, b).then((r) => r.data),
  deleteLog: (id) => axios.delete(`${API}/maint/logs/${id}`).then((r) => r.data),
  // PPE / 保護具
  ppe: (params) => axios.get(`${API}/ppe`, { params }).then((r) => r.data),
  ppeOne: (id) => axios.get(`${API}/ppe/${id}`).then((r) => r.data),
  ppeStats: () => axios.get(`${API}/ppe/stats`).then((r) => r.data),
  createPpe: (b) => axios.post(`${API}/ppe`, b).then((r) => r.data),
  updatePpe: (id, b) => axios.put(`${API}/ppe/${id}`, b).then((r) => r.data),
  inspectPpe: (id, b) => axios.post(`${API}/ppe/${id}/inspect`, b).then((r) => r.data),
  deletePpe: (id) => axios.delete(`${API}/ppe/${id}`).then((r) => r.data),
  // BOM & work orders (Phase 3)
  bom: (itemId) => axios.get(`${API}/bom/${itemId}`).then((r) => r.data),
  setBom: (itemId, b) => axios.put(`${API}/bom/${itemId}`, b).then((r) => r.data),
  boms: () => axios.get(`${API}/boms`).then((r) => r.data),
  laborReport: () => axios.get(`${API}/labor-report`).then((r) => r.data),
  deleteBom: (itemId) => axios.delete(`${API}/bom/${itemId}`).then((r) => r.data),
  moveBom: (itemId, newItemId) => axios.post(`${API}/bom/${itemId}/move`, { new_item_id: newItemId }).then((r) => r.data),
  explodeBom: (itemId, qty) => axios.get(`${API}/bom/${itemId}/explode`, { params: { qty } }).then((r) => r.data),
  workOrders: (params) => axios.get(`${API}/work-orders`, { params }).then((r) => r.data),
  workOrder: (id) => axios.get(`${API}/work-orders/${id}`).then((r) => r.data),
  workOrderStats: () => axios.get(`${API}/work-orders/stats`).then((r) => r.data),
  createWorkOrder: (b) => axios.post(`${API}/work-orders`, b).then((r) => r.data),
  updateWorkOrder: (id, b) => axios.put(`${API}/work-orders/${id}`, b).then((r) => r.data),
  releaseWorkOrder: (id, body) => axios.post(`${API}/work-orders/${id}/release`, body || {}).then((r) => r.data),
  releasePreview: (id) => axios.get(`${API}/work-orders/${id}/release-preview`).then((r) => r.data),
  woSettings: () => axios.get(`${API}/wo-settings`).then((r) => r.data),
  saveWoSettings: (body) => axios.put(`${API}/wo-settings`, body).then((r) => r.data),
  startWorkOrder: (id) => axios.post(`${API}/work-orders/${id}/start`).then((r) => r.data),
  completeWorkOrder: (id, b) => axios.post(`${API}/work-orders/${id}/complete`, b || {}).then((r) => r.data),
  holdWorkOrder: (id, b) => axios.post(`${API}/work-orders/${id}/hold`, b || {}).then((r) => r.data),
  resumeWorkOrder: (id) => axios.post(`${API}/work-orders/${id}/resume`).then((r) => r.data),
  cancelWorkOrder: (id) => axios.post(`${API}/work-orders/${id}/cancel`).then((r) => r.data),
  deleteWorkOrder: (id) => axios.delete(`${API}/work-orders/${id}`).then((r) => r.data),
  scheduleWorkOrder: (id, b) => axios.post(`${API}/work-orders/${id}/schedule`, b).then((r) => r.data),
  productionSchedule: () => axios.get(`${API}/production-schedule`).then((r) => r.data),
  // 分析 (Analytics — Phase 7: OEE / scrap / cross-department)
  analytics: (params) => axios.get(`${API}/analytics`, { params }).then((r) => r.data),
  // 作業区 (work centers — Phase 4 production planning)
  workCenters: () => axios.get(`${API}/work-centers`).then((r) => r.data),
  workCenterPeople: () => axios.get(`${API}/work-centers/people`).then((r) => r.data),
  createWorkCenter: (b) => axios.post(`${API}/work-centers`, b).then((r) => r.data),
  updateWorkCenter: (id, b) => axios.patch(`${API}/work-centers/${id}`, b).then((r) => r.data),
  deleteWorkCenter: (id) => axios.delete(`${API}/work-centers/${id}`).then((r) => r.data),
  // 製造番号 (manufacturing number) — auto serial config for SNS, used inside the WO form
  mfgNoSeq: () => axios.get(`${API}/manufacturing-numbers/seq`).then((r) => r.data),
  setMfgNoSeq: (b) => axios.put(`${API}/manufacturing-numbers/seq`, b).then((r) => r.data),
  mfgNoPreview: () => axios.get(`${API}/manufacturing-numbers/next-preview`).then((r) => r.data),
  // 添付ファイル (attachments — drawings/specs on items & work orders)
  attachments: (entity_type, entity_id) => axios.get(`${API}/attachments`, { params: { entity_type, entity_id } }).then((r) => r.data),
  uploadAttachment: async (entity_type, entity_id, file, onProgress) => {
    // Try LAN-direct upload first; fall back to WAN multipart POST silently.
    const { lanUpload } = await import('@/lib/lanStorage');
    const legacyUpload = (f) => {
      const fd = new FormData();
      fd.append('file', f);
      fd.append('entity_type', entity_type);
      fd.append('entity_id', entity_id);
      return axios.post(`${API}/attachments`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress
          ? (evt) => { if (evt.total) onProgress(evt.loaded, evt.total); }
          : undefined,
      }).then((r) => r.data);
    };
    return lanUpload({
      axios, apiBase: API_BASE, kind: 'mfg_attachment',
      file, extra: { entity_type, entity_id },
      legacyUpload, onProgress,
    });
  },
  attachmentBlob: (id) => axios.get(`${API}/attachments/${id}/download`, { responseType: 'blob' }).then((r) => r.data),
  deleteAttachment: (id) => axios.delete(`${API}/attachments/${id}`).then((r) => r.data),
};

export const ITEM_TYPES = ['raw', 'purchased_part', 'processed_part', 'wip', 'semifinished', 'finished', 'consumable', 'sub_material'];
export const TYPE_BADGE = {
  raw: 'bg-amber-50 text-amber-700 border-amber-200',
  purchased_part: 'bg-sky-50 text-sky-700 border-sky-200',
  processed_part: 'bg-violet-50 text-violet-700 border-violet-200',
  wip: 'bg-blue-50 text-blue-700 border-blue-200',
  semifinished: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  finished: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  consumable: 'bg-zinc-100 text-zinc-600 border-zinc-200',
  sub_material: 'bg-teal-50 text-teal-700 border-teal-200',
};
export const PROCESSING_TYPES = ['in_house', 'subcontracted'];
export const SUPPLIER_TYPES = ['vendor', 'subcontractor', 'both'];
export const SUPPLIER_TYPE_BADGE = {
  vendor: 'bg-zinc-100 text-zinc-700 border-zinc-200',
  subcontractor: 'bg-orange-50 text-orange-700 border-orange-200',
  both: 'bg-violet-50 text-violet-700 border-violet-200',
};
export const LOCATION_KINDS = ['warehouse', 'zone', 'shelf', 'bin'];
export const MOVE_TYPES = ['receipt', 'issue', 'adjust', 'transfer', 'transfer_out', 'transfer_in', 'return'];
export const MOVE_BADGE = {
  receipt: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  issue: 'bg-rose-50 text-rose-700 border-rose-200',
  adjust: 'bg-amber-50 text-amber-700 border-amber-200',
  transfer: 'bg-blue-50 text-blue-700 border-blue-200',
  transfer_out: 'bg-sky-50 text-sky-700 border-sky-200',
  transfer_in: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  return: 'bg-violet-50 text-violet-700 border-violet-200',
};

// ── Phase 2: equipment / maintenance / PPE ──
export const EQUIPMENT_KINDS = ['machine', 'tool', 'jig', 'gauge'];
// B2 · 状態は技術の設備台帳と和集合（貸出中は貸出の承認で付く）
export const EQUIPMENT_STATUSES = ['storage', 'operational', 'maintenance', 'breakdown', 'retired', 'rented', 'on_order'];
export const EQ_STATUS_BADGE = {
  storage: 'bg-sky-50 text-sky-700 border-sky-200',
  on_order: 'bg-violet-50 text-violet-700 border-violet-200',
  operational: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  maintenance: 'bg-amber-50 text-amber-700 border-amber-200',
  breakdown: 'bg-rose-50 text-rose-700 border-rose-200',
  retired: 'bg-zinc-100 text-zinc-500 border-zinc-200',
};
export const EQ_KIND_BADGE = {
  machine: 'bg-orange-50 text-orange-700 border-orange-200',
  tool: 'bg-blue-50 text-blue-700 border-blue-200',
  jig: 'bg-violet-50 text-violet-700 border-violet-200',
  gauge: 'bg-teal-50 text-teal-700 border-teal-200',
};
export const PPE_STATUSES = ['ok', 'attention', 'retired'];
export const PPE_STATUS_BADGE = {
  ok: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  attention: 'bg-rose-50 text-rose-700 border-rose-200',
  retired: 'bg-zinc-100 text-zinc-500 border-zinc-200',
};
export const WO_STATUSES = ['planned', 'released', 'in_progress', 'completed', 'on_hold', 'cancelled'];
export const WO_STATUS_BADGE = {
  planned: 'bg-zinc-100 text-zinc-600 border-zinc-200',
  released: 'bg-blue-50 text-blue-700 border-blue-200',
  in_progress: 'bg-amber-50 text-amber-700 border-amber-200',
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  on_hold: 'bg-rose-50 text-rose-700 border-rose-200',
  cancelled: 'bg-zinc-100 text-zinc-400 border-zinc-200',
};

// ── Phase 7: analytics — scrap reasons (品質捕捉) ──
export const SCRAP_REASONS = ['dimension', 'scratch', 'material', 'equipment', 'operation', 'other'];
